<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Proizvodi</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-data-table
                    class="mt-4"
                    hide-default-footer
                    style="width: 100%;border: 1px solid #ddd;border-radius: 0"
                    :headers="headers"
                    :items="menuItems"
            >
                <!--<template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-btn depressed color="primary" small tile :to="{name: 'meni-id-items-create'}">Add new</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:item.option="{ item }">
                    <v-btn depressed color="primary" small tile @click="edit(item)">Edit</v-btn>
                    <v-btn depressed color="red" dark class="ml-3" small tile @click="remove(item)">Delete</v-btn>
                </template>-->
            </v-data-table>
        </v-col>
    </v-row>
</template>


<script>
    import bitPage from "../../../../components/layout/page";
    import confirmDialog from '../../../../components/global/confirm'
    import config from '../../../../config'

    export default {
        components: {
            bitPage,
            confirmDialog
        },
        head() {
            return {
                config: config,
                title: 'BitLab CMS'
            }
        },
        data: () => ({
            breadcrumbs: [
                {
                    text: 'Narudzbine',
                    disabled: true
                },
            ],
            headers: [
                {text: 'ID', value: 'id'},
                {text: 'Name', value: 'name'},
                {text: 'Kolicina', value: 'quantity'},
                {text: 'Option', value: 'option'}
            ],
            items: [],
            dialog: false,
            tab: 0,
            selectedItem: null,
            position: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            categoryItems: [],
            menuItems: [],
            loading: false
        }),
        created() {
            this.getMenuItem();
        },
        methods: {
            getMenuItem() {
                this.menuItems = [];
                this.axios.get(`/invoices/${this.$route.params.id}`)
                    .then(res => {
                        res.data.orders.forEach(item => {
                            let lang = item.product.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.title ? lang.title : '';
                            if (item['name'] !== '') this.menuItems.push(item)
                        })
                    })
            }
        },
        computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            }
        }

    }
</script>
